<template>
  <div class="neilian">
    <iframe v-if="show" :src="url" style="height: 800px;width:1200px;margin:0 auto;" frameborder="0"></iframe>
  </div>
</template>

<script>
import { getAuthDetailReport } from "@/api/coal";
export default {
  name: "relatedProducts",
  data() {
    return {
      show: false,
      url: 'http://groupapp.risun.com:9003/ZBZHReport/ReportServer?reportlet=RISUN%2F%5B5546%5D%5B54c1%5D%5B7814%5D%5B7a76%5D%2Fcoal_use.cpt'
    }
  },
  created() {
    this.showPage();
  },
  methods: {
    showPage() {
      getAuthDetailReport().then((res) => {
        if (res.msg) {
          this.show = true;
        }
      });
    }
  } 
}
</script>

<style scoped>
.neilian {
  height: 800px;
  width: 1200px;
  margin: 30px auto;
  text-align: center;
}
</style>
